import { StyleSheet } from 'react-native';

export default StyleSheet.create({
  container: {
    paddingVertical: 8,
    borderRadius: 0,
    justifyContent: 'center',
    backgroundColor:'#fff'
  },
});
